module.exports = __webpack_public_path__ + "img/welcome-01.473b9899.jpg";